import type { Lead } from '@/core/types/lead';
import { createSeedLeads } from './mockSeed';
import { moduleMockStore } from './moduleMockStore';

const leadsKey = 'crm-demo-leads-v1';
const versionKey = 'crm-demo-version-counter-v1';

const canUseStorage = (): boolean => typeof localStorage !== 'undefined';

export const mockDatabase = {
  getLeads(): Lead[] {
    if (!canUseStorage()) return createSeedLeads();
    const raw = localStorage.getItem(leadsKey);
    if (!raw) {
      const seed = createSeedLeads();
      localStorage.setItem(leadsKey, JSON.stringify(seed));
      return seed;
    }

    try {
      return JSON.parse(raw) as Lead[];
    } catch {
      const seed = createSeedLeads();
      localStorage.setItem(leadsKey, JSON.stringify(seed));
      return seed;
    }
  },

  saveLeads(leads: Lead[]): void {
    if (canUseStorage()) localStorage.setItem(leadsKey, JSON.stringify(leads));
  },

  nextRowVersion(): string {
    const current = canUseStorage() ? Number(localStorage.getItem(versionKey) || '1000') : Date.now();
    const next = current + 1;
    if (canUseStorage()) localStorage.setItem(versionKey, String(next));
    const bytes = new Uint8Array(8);
    new DataView(bytes.buffer).setBigUint64(0, BigInt(next));
    return btoa(String.fromCharCode(...bytes));
  },

  reset(): void {
    if (!canUseStorage()) return;
    localStorage.removeItem(leadsKey);
    localStorage.removeItem(versionKey);
    moduleMockStore.reset();
  },
};
